import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const parseDateValue = (value) => {
	if(!value) return null;
	if(value instanceof Date) return isNaN(value.getTime()) ? null : value;

	const normalized = String(value).trim();

	if(/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
		const [year, month, day] = normalized.split("-");
		const date = new Date(Number(year), Number(month) - 1, Number(day));
		return isNaN(date.getTime()) ? null : date;
	}

	if(/^\d{2}\/\d{2}\/\d{4}$/.test(normalized)) {
		const [day, month, year] = normalized.split("/");
		const date = new Date(Number(year), Number(month) - 1, Number(day));
		return isNaN(date.getTime()) ? null : date;
	}

	if(/^\d{8}$/.test(normalized)) {
		const day = normalized.substring(0, 2);
		const month = normalized.substring(2, 4);
		const year = normalized.substring(4);
		const date = new Date(Number(year), Number(month) - 1, Number(day));
		return isNaN(date.getTime()) ? null : date;
	}

	return null;
};

const formatDateValue = (date) => {
	if(!date || !(date instanceof Date) || isNaN(date.getTime())) return "";

	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
};

const DatePickerField = ({ label, value, onChange, minDate, maxDate }) => {
	const selectedDate = parseDateValue(value);
	const parsedMinDate = parseDateValue(minDate);
	const parsedMaxDate = parseDateValue(maxDate);

	return (
		<div className="input-group">
			<DatePicker
				selected={selectedDate}
				onChange={(date) => onChange(formatDateValue(date))}
				dateFormat="dd/MM/yyyy"
				className="inputBoxIn form-control forminput w-100"
				placeholderText={label}
				minDate={parsedMinDate || undefined}
				maxDate={parsedMaxDate || undefined}
				showMonthDropdown
				showYearDropdown
				dropdownMode="select"
				onKeyDown={(event) => event.preventDefault()}
				onChangeRaw={(event) => event.preventDefault()}
			/>
		</div>
	);
};

export default DatePickerField;
